import { api } from './client';
import type { CompanyDto, CreateCompanyRequest, UpdateCompanyRequest } from '../types/company';

export const companyApi = {
  get: () =>
    api.get<CompanyDto>('/company'),

  create: (data: CreateCompanyRequest) =>
    api.post<number>('/company', data),

  update: (data: UpdateCompanyRequest) =>
    api.put<void>('/company', data),
};
